// @ts-nocheck
import {
    Box,
    Stack,
    styled
} from "@mui/material";
import React from "react";
import { dateToUsFormat } from "utils/helpers";

export const columns = [
  {
    label: "Date",
    field: "change_date",
    xs: 2.5,
    sm: 2.5,
    md: 2.5,
    renderer: ({ change_date }) => dateToUsFormat(change_date),
  },
  {
    label: "Changed",
    field: "field_changed",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
  },
  {
    label: "New Value",
    field: "new_value",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ new_value }) => (
      <Box sx={{ paddingRight: "10px" }}>
        {new_value?.split("\n").map((line, index) => (
          <React.Fragment key={`${line}-${index}`}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </Box>
    ),
  },
  {
    label: "Author",
    field: "specialist_label",
    xs: 6,
    sm: 6,
    md: 6,
    renderer: ({ specialist_label }) => <>{specialist_label ?? " - "}</>,
  },
];

export const mobileColumns = [
  {
    label: "Date",
    field: "change_date",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ change_date }) => dateToUsFormat(change_date),
  },
  {
    label: "Changed",
    field: "field_changed",
    xs: 3,
    sm: 3,
    md: 3,
  },
  {
    label: "New Value",
    field: "new_value",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ new_value }) => (
      <Box sx={{ paddingRight: "10px" }}>
        {new_value?.split("\n").map((line, index) => (
          <React.Fragment key={`${line}-${index}`}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </Box>
    ),
  },
  {
    label: "Author",
    field: "specialist_label",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ specialist_label }) => <>{specialist_label ?? " - "}</>,
  },
];

export const Container = styled(Stack)`
  flex: 1 1 auto;
  flex-direction: column;
  overflow-y: auto;
  gap: 1rem;
  padding: 1rem 2rem 0 2rem;

  @media screen and (max-width: 1024px) {
    padding: 1rem 1rem 0 1rem;
  }
`;
